(function () {
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  function init(root) {
    const section = root.closest('[id^="MainProduct-"]');
    const viewport = root.querySelector('.cainte-2col__viewport');
    const track = root.querySelector('[data-cainte-2col-track]');
    const slides = Array.from(root.querySelectorAll('[data-cainte-2col-slide]'));
    const prev = root.querySelector('[data-cainte-2col-prev]');
    const next = root.querySelector('[data-cainte-2col-next]');
    const thumbs = Array.from(root.querySelectorAll('[data-cainte-2col-thumb]'));
    const thumbsWrapper = root.querySelector('[data-cainte-2col-thumbs]');

    if (!section || !viewport || !track || slides.length <= 1) return;

    const sectionId = section.id.replace('MainProduct-', '');
    const variantMapEl = document.getElementById(`VariantMediaMap-${sectionId}`);
    const variantMap = variantMapEl ? JSON.parse(variantMapEl.textContent) : [];

    let index = 0;

    const getGap = () => {
      const s = getComputedStyle(track);
      const g = parseFloat(s.gap || s.columnGap || '0');
      return Number.isFinite(g) ? g : 0;
    };

    const getStepAndBounds = () => {
      const w = slides[0].getBoundingClientRect().width;
      const step = w + getGap();
      const lastIndex = Math.max(0, slides.length - 2);
      const maxX = 0;
      const minX = -lastIndex * step;

      return { step, lastIndex, minX, maxX };
    };

    const setX = (x, noAnim) => {
      if (noAnim) {
        const t = track.style.transition;
        track.style.transition = 'none';
        track.style.transform = `translateX(${x}px)`;
        void track.offsetHeight;
        track.style.transition = t || '';
      } else {
        track.style.transform = `translateX(${x}px)`;
      }
    };

    const getX = () => {
      const tr = track.style.transform;
      if (!tr || tr === 'none') return 0;
      const m = tr.match(/translateX\(([-0-9.]+)px\)/);
      return m ? parseFloat(m[1]) : 0;
    };

    const updateArrowsByIndex = (lastIndex) => {
      if (prev) prev.hidden = index === 0;
      if (next) next.hidden = index >= lastIndex;
    };

    const snapToIndex = (targetIndex, noAnim) => {
      const { step, lastIndex, minX, maxX } = getStepAndBounds();
      index = clamp(targetIndex, 0, lastIndex);
      const x = clamp(-index * step, minX, maxX);
      setX(x, noAnim);
      updateArrowsByIndex(lastIndex);
      updateActiveThumb();
    };

    snapToIndex(0, true);

    if (prev) prev.addEventListener('click', () => snapToIndex(index - 1, false));
    if (next) next.addEventListener('click', () => snapToIndex(index + 1, false));



    let isDown = false;
    let startX = 0;
    let startTranslate = 0;
    let lastMoveTime = 0;
    let lastMoveX = 0;
    let velocity = 0;
    let raf = null;

    const stopInertia = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    };

    const startInertia = () => {
      stopInertia();

      const friction = 0.82;
      const minVel = 0.09;
      const { step, lastIndex, minX, maxX } = getStepAndBounds();

      const tick = () => {
        let x = getX();
        x += velocity * 16;

        if (x > maxX) {
          x = maxX;
          velocity *= 0.35;
        }
        if (x < minX) {
          x = minX;
          velocity *= 0.35;
        }

        setX(x, true);
        velocity *= friction;

        if (Math.abs(velocity) < minVel) {
          const rawIndex = Math.round(-x / step);
          index = clamp(rawIndex, 0, lastIndex);
          setX(-index * step, false);
          updateArrowsByIndex(lastIndex);
          stopInertia();
          return;
        }

        raf = requestAnimationFrame(tick);
      };

      raf = requestAnimationFrame(tick);
    };

    const pointerDown = (e) => {
      if (e.target.closest('.cainte-2col__arrow')) return;

      stopInertia();
      isDown = true;
      viewport.classList.add('is-dragging');

      startX = e.clientX;
      startTranslate = getX();

      lastMoveTime = performance.now();
      lastMoveX = e.clientX;
      velocity = 0;

      viewport.setPointerCapture?.(e.pointerId);
    };

    const pointerMove = (e) => {
      if (!isDown) return;

      const { minX, maxX, lastIndex, step } = getStepAndBounds();
      const dx = e.clientX - startX;
      let x = startTranslate + dx;

      if (x > maxX) x = maxX + (x - maxX) * 0.25;
      if (x < minX) x = minX + (x - minX) * 0.25;

      setX(x, true);

      const now = performance.now();
      const dt = now - lastMoveTime;
      if (dt > 0) {
        const dxv = e.clientX - lastMoveX;
        velocity = dxv / dt;
        lastMoveTime = now;
        lastMoveX = e.clientX;
      }

      const approxIndex = clamp(Math.round(-x / step), 0, lastIndex);
      index = approxIndex;
      updateArrowsByIndex(lastIndex);
    };

    const pointerUp = () => {
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove('is-dragging');

      if (Math.abs(velocity) > 0.05) {
        startInertia();
        return;
      }

      const { step, lastIndex, minX, maxX } = getStepAndBounds();
      const x = clamp(getX(), minX, maxX);
      const rawIndex = Math.round(-x / step);
      index = clamp(rawIndex, 0, lastIndex);
      setX(-index * step, false);
      updateArrowsByIndex(lastIndex);
    };

    viewport.addEventListener('pointerdown', pointerDown);
    window.addEventListener('pointermove', pointerMove, { passive: true });
    window.addEventListener('pointerup', pointerUp, { passive: true });
    window.addEventListener('pointercancel', pointerUp, { passive: true });

    window.addEventListener('resize', () => snapToIndex(index, true));

    function scrollToVariantMedia(variantId) {
      if (!variantId) return;

      const variant = variantMap.find((v) => String(v.id) === String(variantId));
      if (!variant || !variant.featured_media_id) return;

      const targetSlideIndex = slides.findIndex(
        (slide) => String(slide.dataset.mediaId) === String(variant.featured_media_id)
      );

      if (targetSlideIndex === -1) return;

      snapToIndex(targetSlideIndex, false);
    }

    function getCurrentVariantId() {
      const variantInput =
        section.querySelector('product-form input[name="id"]') ||
        section.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        section.querySelector('input[name="id"]');

      return variantInput ? variantInput.value : null;
    }

    function syncFromCurrentVariant() {
      const variantId = getCurrentVariantId();
      if (variantId) scrollToVariantMedia(variantId);
    }

    function updateActiveThumb() {
      thumbs.forEach((thumb) => thumb.classList.remove('is-active'));

      const first = thumbs[index];
      const second = thumbs[index + 1];

      if (first) first.classList.add('is-active');
      if (second) second.classList.add('is-active');
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const targetIndex = Number(thumb.getAttribute('data-index'));
        if (Number.isNaN(targetIndex)) return;

        snapToIndex(targetIndex, false);
      });
    });
    // sync au chargement
    syncFromCurrentVariant();

    // sync quand on change les options de variante
    section.addEventListener('change', function (event) {
      const el = event.target;
      if (!el.closest('variant-radios, variant-selects')) return;

      // Dawn met parfois à jour l'input hidden juste après le change
      setTimeout(syncFromCurrentVariant, 80);
    });

    // sync aussi après les rerenders Dawn
    const observer = new MutationObserver(() => {
      syncFromCurrentVariant();
    });

    const variantInput =
      section.querySelector('product-form input[name="id"]') ||
      section.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      section.querySelector('input[name="id"]');

    if (variantInput) {
      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cainte-2col]').forEach(init);
  });
})();